import { $axios } from "@/config/axios";

export default {
  saveGatewayDetails: function(payload) {
    return $axios.post(`/gateways`, payload);
  },
  fetchGatewayData: function(params) {
    return $axios.get("/gateways", { params });
  },
  fetchGatewayInfoData: function(params) {
    return $axios.get("/gateways-with-device-info", { params });
  },
  fetchGatewayDeviceInfoData: function(params) {
    return $axios.get("/gateways-with-device-info-with-pond-wise-data", {
      params,
    });
  },
};
